import { useSelector } from "react-redux";

import { useEffect, useState } from "react";
import moment from "moment";
import _ from "lodash";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import CargoBasicInfoComponent from "./cargo-basic-info";
import VehicleCard from "./vehicle-card";
import { toast } from "react-toastify";
import ModalQuotesDetailsComponent from "./modal-quotes-detail";
import ModalLeadComponent from "./cargoleadEdit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectProductsListItems } from "../../../../../redux/products/selector";
import { selectCargoLeadsCreatedItem } from "../../../../../redux/cargo-lead/selector";
import { selectShippingTypesListItems } from "../../../../../redux/shippingTypes/selector";
import { selectCargoQuotesCreatedItem } from "../../../../../redux/cargo-quotes/selector";
import { selectOrganizationUnitsListItems } from "../../../../../redux/organizationUnits/selector";
import { selectVehiclesListItems } from "../../../../../redux/vehicles/selector";
import { selectCmsSettingsListItems } from "../../../../../redux/cmsSettings/selector";
import { selectProductTypesListItems } from "../../../../../redux/product-types/selector";
import { selectCategoriesListItems } from "../../../../../redux/categories/selector";
import { selectOrdersCreatedItem } from "../../../../../redux/orders/selector";
import { selectPaymentMethodsQueryItems } from "../../../../../redux/payment-methods/selector";
import { cargoQuotes } from "../../../../../redux/cargo-quotes/action";
import { deepCopy } from "../../../../../common/services/common.service";
import Popup from "../../../../../common/components/popup";
import { settings } from "../../../../../redux/settings/actions";
import { cargoLeads } from "../../../../../redux/cargo-lead/action";
import { addPayment } from "../../../../../redux/addPayment/action";
import { orders } from "../../../../../redux/orders/action";
import { vehicles } from "../../../../../redux/vehicles/action";
import { categories } from "../../../../../redux/categories/action";
import { shippingTypes } from "../../../../../redux/shippingTypes/action";
import { productTypes } from "../../../../../redux/product-types/action";
import storePersist from "../../../../../redux/storePersist";
import { selectCustomersListItems } from "../../../../../redux/customers/selector";
import { customers } from "../../../../../redux/customers/action";
import { RotatingLines } from "react-loader-spinner";
import CommonModalMobile from "../../../../../models/common-modal-mobile";
import PopupMobile from "../../../../../common/components/popup-mobile.component";
import { selectVehicleCategoriesListItems } from "../../../../../redux/vehicle-categories/selector";
import ModalEwayComponent from "./modal-eway-details";
import { vehicleCategories } from "../../../../../redux/vehicle-categories/action";

declare let Razorpay: any;
let currentChange: any = {};
const CargoBookings = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const userInfo = storePersist?.get("userProfile")?.current?.items;
    var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
    var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
    const MODE = 'secure';
    const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;


    //UseSelector Declaration
    const paymentSettings = useSelector(selectCmsSettingsListItems)
    const quoteDetails = useSelector(selectCargoQuotesCreatedItem)
    const customerListData = useSelector(selectCustomersListItems)
    const leadCreateData = useSelector(selectCargoLeadsCreatedItem)
    const vehicleData = useSelector(selectVehiclesListItems)
    const shippingTypesDetails = useSelector(selectShippingTypesListItems)
    const productTypesListItems = useSelector(selectProductTypesListItems)
    const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
    const ProductLists = useSelector(selectProductsListItems)
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
    const vehicleCategoryData = useSelector(selectVehicleCategoriesListItems)
    const productTypeCargo = productTypesListItems?.result?.items.filter(
        (data: any) => data.IsCargoOrder === true
    )
    const isOpenComponent = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems[0]?.value?.value >= 50000;


    // useState Declaration
    const [razorpaySettings, setRazorpaySettings] = useState<any>([])
    const [paymentGateway, setPaymentGateway] = useState<any>([]);
    const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
    const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
    const [isQuote, setIsQuote] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [enableConfirm, setEnableConfirm] = useState<boolean>(false)
    const [orderItem, setOrderItem] = useState<any>(undefined);
    const [paymentSelectedInput, setPaymentSelectedInput] = useState<any>(undefined);
    const [paymentMode, setPaymentMode] = useState<any>(undefined);
    const [selected, setSelected] = useState<any>();
    const [leadItem, setLeadItem] = useState<any>(undefined);
    const [isLead, setIsLead] = useState<boolean>(false)
    const [generateIds, setGenerateIds] = useState<any>([]);
    const [enablePlaceOrder, setEnablePlaceOrder] = useState(false);
    const [selectedVehicleItem, setSelectedVehicleItem] = useState<any>({});
    const [selectedEstimateItem, setSelectedEstimateItem] = useState<any>({});
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
    const [activeStep, setActiveStep] = useState(0);
    const [cargoValues, setCargoValues] = useState<any>()
    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>()

    const [pickupLocations, setPickupLocations] = useState<any>({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });
    const [dropLocations, setDropLocations] = useState<any>({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });


    // Generate Unique Id
    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };
    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
            fulfillment_id: generateUniqueId(),
            item_id: generateUniqueId(),
            order_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };


    //cargo basic details functions
    const handleChange: any = (event: any, field: string) => {
        setCargoValues({ ...cargoValues, [field]: event })
        setSelectedEstimateItem({ ...selectedEstimateItem, [field]: event });
    }


    //Search Customer function
    let filterCustomer = _.find(customerListData.result.items, ['Id', cargoValues?.CustomerId]);
    const handleCustomerSearch = async ({ event }: any) => {
        await dispatch(customers.resetAction({ actionType: 'list' }))
        await dispatch(customers.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`, entity: 'categories', jsonData: {
                "Filters": [
                    {
                        "FieldName": "UserName",
                        "FilterOperatorId": 6,
                        "FieldValue": event,
                        "FieldType": "text"
                    }
                ],
            }
        }))
    }



    const handleEstimate = async (itemData: any) => {
        const vehicleData: any = {
            vehicleCategoryId: itemData?.LogisticsVehicleCategoryId,
            vehicleId: itemData?.Id,
            vehicleName: itemData?.VehicleName,
            VehicleBodyTypeId: itemData?.VehicleBodyTypeId,
            LoadingCapacity: itemData?.LoadingCapacity,
            TripVehicleBasePrice: itemData?.TripVehicleBasePrice,
            VehicleWeight: itemData?.VehicleWeight,
            RegistrationNumber: itemData?.RegistrationNumber,
        }
        setSelectedVehicleItem(vehicleData)

        if (!selectedEstimateItem?.CategoryId || !selectedEstimateItem?.ProductValue || !itemData?.Id) {
            toast.error("Please fill in the Product Type and Product Value details, and select the Vehicle Type.");
            return; // Stop further execution if validation fails
        } else {
            await handleSavePackageItem(vehicleData)
        }

    }

    //Set the update Address detail modal
    const handleEstimateleadSubmit = async (lead: any, pickup: any, drop: any) => {

        await setSelectedEstimateItem(lead)
        await setPickupLocations(pickup)
        await setDropLocations(drop)
        await handleLeadClose()
    };
    //Close Address detail modal
    const handleLeadClose = () => {
        setLeadItem(undefined)
        setOrderItem(undefined)

    }
    //Edit Address detail modal
    const NewLeadPopup = ({ handleEstimateleadSubmit }: any) => {
        const [localLead, setLocalLead] = useState(deepCopy(selectedEstimateItem));
        const [localPickup, setLocalPickup] = useState(deepCopy(pickupLocations));
        const [localDrop, setLocalDrop] = useState(deepCopy(dropLocations));

        const handleLocalFormChange = (value, field) => {
            setLocalLead(prev => ({
                ...prev,
                [field]: value,
            }));
            setLocalPickup(prev => ({
                ...prev,
                [field]: value,
            }));
            setLocalDrop(prev => ({
                ...prev,
                [field]: value,
            }));
        };

        const handleFormSubmit = () => {
            setLocalLead(localLead);
            handleEstimateleadSubmit(localLead, localPickup, localDrop)
        };

        return (
            <>
                <PopupMobile onback={handleLeadClose} onClose={handleLeadClose}>
                    <ModalLeadComponent
                        handleEstimateleadSubmit={handleFormSubmit}
                        selectedEstimateItem={localLead}
                        dropLocations={localDrop}
                        pickupLocations={localPickup}
                        setDropLocations={setLocalDrop}
                        setPickupLocations={setLocalPickup}
                        handleInnerFormChange={handleLocalFormChange}
                    />

                </PopupMobile>
            </>
        )
    }
    //Open Edit Address detail modal
    const onEdit = async () => {
        setLeadItem({
            id: 0
        })
    }

    //Estimate popup
    const NewEstimatePopup = ({ handleSavePackageItem, handleOrderBooking }: any) => {
        const [localPackItems, setLocalPackItems] = useState(deepCopy(selectedEstimateItem));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalPackItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };

        const handleFormPayment = () => {
            handleOrderBooking()
        }
        const handlePaymentInput = (e: any, item: any) => {
            setSelected(item.value)
            setPaymentMode(item)
            setPaymentSelectedInput(e.target.value)
        }
        const closeModal = () => {
            generateIdValue()
            setOrderItem(undefined)
        }

        const handleBookLater = () => {
            generateIdValue()
            setOrderItem(undefined)
            generateIdValue()
            setCargoValues({})
            setPickupLocations({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            })
            setDropLocations({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            })
            setEnableConfirm(false)
            setIsOpenPayment(false)
            setActiveStep((prevActiveStep) => prevActiveStep - 1)
            navigate('/transport-agent/bookings/cargo')
        }
        const handleFileURlSubmit = async (urlData) => {
            await setIsOpenPayment(true)
            await setMediaFiles(
                [{
                    Id: 0,
                    FileTypeId: urlData?.FileType === 'image' ? 10 : 20,
                    OwnerId: 0,
                    OwnerType: "shipping",
                    OwnerTypeId: 1007,
                    FileMappingURL: urlData?.DocumentPath
                }]
            )

        }
        return (
            <>
                <PopupMobile onClose={closeModal} onback={closeModal}>

                    {enableConfirm && isOpenComponent && !isOpenPayment ? <ModalEwayComponent
                        handleFileURlSubmit={handleFileURlSubmit}
                        selectedVehicleItem={selectedVehicleItem}
                        dropLocations={dropLocations}
                        pickupLocations={pickupLocations}
                        quoteDetails={quoteDetails} />
                        : <ModalQuotesDetailsComponent
                            handleBookLater={handleBookLater}
                            selectedVehicleItem={selectedVehicleItem}
                            dropLocations={dropLocations}
                            pickupLocations={pickupLocations}
                            quoteDetails={quoteDetails}
                            enablePlaceOrder={enablePlaceOrder}
                            handlePayment={handleFormPayment}
                            isLoading={isLoading}
                            paymentSettings={paymentSettings}
                            paymentSelectedInput={paymentSelectedInput}
                            handlePaymentInput={handlePaymentInput} />}
                </PopupMobile>
            </>
        )
    }



    // Step 1: Submit Lead
    const handleLeadSubmit = async (event: any) => {
        event?.preventDefault()
        await setSelectedEstimateItem({})
        await dispatch(settings.set({
            cargoLead: {}
        }))
        // Validation for required fields
        if (

            !cargoValues?.date ||
            !pickupLocations?.description ||
            !dropLocations?.description
        ) {
            toast.error("All fields are required. Please fill in all the details.");
            return;
        }
        // Validate phone number length
        if (cargoValues?.PhoneNumber?.length < 10) {
            toast.error("Please enter a valid phone number with at least 10 digits.");
            return;
        }
        // Parse addresses
        const fromAddressData = _.split(pickupLocations?.description, ',');
        const toAddressData = _.split(dropLocations?.description, ',');
        try {
            // Dispatch actions if validations pass
            await dispatch(settings.set({
                cargoLead: {
                    date: cargoValues?.date,
                    name: cargoValues?.name,
                    Name: cargoValues?.IsExistingUser ? filterCustomer?.UserName : cargoValues?.Name,
                    toPhoneNumber: cargoValues?.toPhoneNumber,
                    PhoneNumber: cargoValues?.IsExistingUser ? filterCustomer?.PhoneNumber : cargoValues?.PhoneNumber,
                },
                pickupLocations,
                dropLocations,
            }))
            await setSelectedEstimateItem({
                date: cargoValues?.date,
                name: cargoValues?.name,
                Name: cargoValues?.IsExistingUser ? filterCustomer?.UserName : cargoValues?.Name,
                toPhoneNumber: cargoValues?.toPhoneNumber,
                PhoneNumber: cargoValues?.IsExistingUser ? filterCustomer?.PhoneNumber : cargoValues?.PhoneNumber,
                Pickup: pickupLocations.description || '',
                Drop: dropLocations.description || '',
            })
            await setIsButtonLoading(true)
            await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
            await dispatch(cargoLeads.create({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
                    "Records": [
                        {
                            Context: {
                                transaction_id: generateIds?.transaction_id,
                                message_id: generateIds?.message_id,
                            },
                            Message: {
                                LeadInfo: {
                                    Name: cargoValues?.IsExistingUser ? filterCustomer?.AccountName : cargoValues?.Name,
                                    Email: cargoValues?.IsExistingUser ? filterCustomer?.Email : cargoValues?.Email,
                                    PhoneNumber: cargoValues?.IsExistingUser ? filterCustomer?.PhoneNumber : cargoValues?.PhoneNumber,
                                    date: cargoValues?.date,
                                    Description: cargoValues?.Description || '',
                                    IsExistingUser: cargoValues?.IsExistingUser,
                                    LeadPayload: {
                                        weight: {
                                            unit: '',
                                            value: 0
                                        },
                                        dimensions: {
                                            length: {
                                                unit: '',
                                                value: 0
                                            },
                                            breadth: {
                                                unit: '',
                                                value: 0
                                            },
                                            height: {
                                                unit: '',
                                                value: 0
                                            }
                                        },
                                        category: '',
                                        value: {
                                            currency: 'INR',
                                            value: 0
                                        },
                                        dangerous_goods: false
                                    },
                                    start: {
                                        location: {
                                            gps: `${pickupLocations?.lat},${pickupLocations?.lng}`,
                                            address: {
                                                name: cargoValues?.IsExistingUser ? filterCustomer?.AccountName : cargoValues?.Name,
                                                building: pickupLocations?.description,
                                                locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                                                city: pickupLocations?.name,
                                                state: fromAddressData[3],
                                                country: 'India',
                                                area_code: pickupLocations?.pincode,
                                            },
                                        },
                                        contact: {
                                            phone: cargoValues?.IsExistingUser ? filterCustomer?.PhoneNumber : cargoValues?.PhoneNumber || '',
                                            email: cargoValues?.IsExistingUser ? filterCustomer?.Email : cargoValues?.Email || '',
                                        }
                                    },

                                    end: {
                                        location: {
                                            gps: `${dropLocations?.lat},${dropLocations?.lng}`,
                                            address: {
                                                name: cargoValues?.name,
                                                building: dropLocations?.description,
                                                locality: `${toAddressData[0]},${toAddressData[1]}`,
                                                city: dropLocations?.name,
                                                state: toAddressData[3],
                                                country: 'India',
                                                area_code: dropLocations?.pincode,
                                            },
                                        },
                                        contact: {
                                            phone: cargoValues?.PhoneNumber,
                                            email: ""
                                        }
                                    },
                                }
                            }
                        }
                    ]
                }
            }))
            await setIsLead(true)
            await setIsButtonLoading(false)
        } catch (error) {
            toast.error("An error occurred while submitting the form. Please try again.");
        }

    }

    useEffect(() => {
        if (isLead && leadCreateData?.isSuccess) {
            // Proceed to next step
            handleNext();
            setIsLead(false)
        }
    }, [isLead])

    //Step 2: Submit Quote
    const handleSavePackageItem = async (data: any) => {
        await generateIdValue()
        await setIsLoading(true)
        await dispatch(cargoQuotes.resetAction({ actionType: 'create' }))
        // let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', 'Immediate Delivery']);
        let shippingType = shippingTypesDetails.result.items[0];
        const fromAddressData = _.split(pickupLocations?.description, ',');
        const toAddressData = _.split(dropLocations?.description, ',');
        const valueData = {
            order: {
                IsCargoOrder: true,
                provider: {
                    id: 0,
                    locations: []
                },
                items:
                    [{
                        id: String(shippingType?.Id) || 0,
                        fulfillment_id: generateIds?.fulfillment_id,
                        category_id: shippingType?.ShippingTypeName || "",
                        descriptor: {
                            code: "P2P" // shipmentType (library call)
                        },
                        time: {
                            label: "",
                            duration: "",
                            timestamp: cargoValues?.date || ""
                        }
                    },
                    ],
                billing: {},
                payment: {},
                LinkedItems: [{
                    CategoryId: selectedEstimateItem?.CategoryId,
                    LogisticsProductId: 0,
                    LogisticsVariantId: 0,
                    quantity: {
                        count: 0,
                        measure: {
                            unit: "kg",
                            value: 0
                        }
                    },
                    weight: {
                        unit: "mm",
                        value: 0
                    },
                    dimensions: {
                        length: {
                            unit: "mm",
                            value: 0
                        },
                        breadth: {
                            unit: "mm",
                            value: 0
                        },
                        height: {
                            unit: "mm",
                            value: 0
                        }
                    },
                    value: {
                        currency: "INR",
                        value: selectedEstimateItem?.ProductValue
                    },
                    dangerous_goods: false
                }],
                fulfillments: [
                    {
                        id: generateIds?.fulfillment_id,
                        type: 'Delivery_and_Self_Pickup',
                        start: {
                            location: {
                                gps: `${pickupLocations?.lat} ,${pickupLocations?.lng}`,
                                address: {
                                    name: selectedEstimateItem?.Name,
                                    building: fromAddressData[1],
                                    locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                                    city: pickupLocations?.name,
                                    state: fromAddressData[3] || 'TamilNadu',
                                    country: 'India',
                                    area_code: pickupLocations?.pincode || ''
                                }
                            },
                            contact: {
                                phone: selectedEstimateItem?.PhoneNumber,
                                email: ''
                            }
                        },
                        end: {
                            location: {
                                gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
                                address: {
                                    name: selectedEstimateItem?.name,
                                    building: toAddressData[1],
                                    locality: `${toAddressData[0]},${toAddressData[1]}`,
                                    city: dropLocations?.name,
                                    state: toAddressData[3] || 'TamilNadu',
                                    country: 'India',
                                    area_code: dropLocations?.pincode || ''
                                }
                            },
                            contact: {
                                phone: selectedEstimateItem?.toPhoneNumber,
                                email: ''
                            }
                        },
                        vehicle: {
                            vehicleCategoryId: data?.vehicleCategoryId,
                            vehicleId: data?.vehicleId,
                            vehicleName: data?.vehicleName,
                            weight: data?.VehicleWeight,
                            loading_capacity: data?.LoadingCapacity,
                            registration: data?.RegistrationNumber,
                            TripVehicleBasePrice: data?.TripVehicleBasePrice,
                            VehicleBodyTypeId: data?.VehicleBodyTypeId
                        }
                    }
                ]
            }
        }
        if (pickupLocations?.description !== dropLocations?.description) {
            await dispatch(cargoQuotes.create(
                {
                    url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
                    jsonData: {
                        Records: [{
                            context: {
                                transaction_id: leadCreateData?.result?.Records[0]?.Context?.transaction_id,
                                message_id: generateIds?.item_id,
                            },
                            message: valueData,
                        }]
                    }
                }))
            await setIsQuote(true)
            await setIsLoading(false)
            await setIsLoading(false)
            setEnableConfirm(true)
        }
        else {
            setIsLoading(false)
            toast.error("The Pickup and Drop addresses must be different.")
        }
    }

    useEffect(() => {
        if (isQuote && quoteDetails?.isSuccess) {
            // Open estimate modal
            setOrderItem({
                id: 0
            })
            setIsQuote(false)
        } else {
            setIsQuote(false)
        }

    }, [isQuote])




    //Step 3: Add Payment
    const handleOrderBooking = async () => {
        await setIsLoading(true)
        await dispatch(addPayment.update({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
                Records: [{
                    Context: {
                        transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                        message_id: generateIds?.message_id,
                    },
                    Message: {
                        Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
                        OwnerType: 'LogisticsOrder',
                        PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
                        PaymentRemarks: 'LogisticsOrder',
                        PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
                        PaymentGatewayId: paymentGateway[0]?.Id || 0,
                    },
                }

                ],
            }
        }))
        await dispatch(orders.resetAction({ actionType: 'create' }))
        await setIsPaymentAdded(true);


    }
    // Step 4: Confirm Logistics Order
    useEffect(() => {
        if (isPaymentAdded) {
            const isMediaFile = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems[0]?.value?.value >= 50000;
            const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
                const data = {
                    id: item?.id,
                    fulfillment_id: item?.fulfillment_id,
                    category_id: item?.category_id,
                    descriptor: {
                        code: item?.descriptor?.code
                    },
                    time: {
                        label: null,
                        duration: null,
                        timestamp: item?.time?.timestamp
                    }
                };
                return data;
            });

            const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
                const data = {
                    "@ondc/org/item_id": item?.['@ondc/org/item_id'],
                    "@ondc/org/title_type": item?.['@ondc/org/title_type'],
                    "price": {
                        "currency": item?.price?.currency,
                        "value": item?.price?.value
                    }
                };
                return data;
            });
            const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
                const data = {
                    "id": item?.id,
                    "type": item?.type,
                    "@ondc/org/awb_no": null,
                    "start": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.start?.location?.gps,
                            "address": {
                                "name": item?.start?.location?.address?.name,
                                "building": item?.start?.location?.address?.building,
                                "locality": item?.start?.location?.address?.locality,
                                "city": item?.start?.location?.address?.city,
                                "state": item?.start?.location?.address?.state,
                                "country": item?.start?.location?.address?.country,
                                "area_code": item?.start?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.start?.contact?.phone || '',
                            "email": item?.start?.contact?.email || ''
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null

                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "end": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.end?.location?.gps,
                            "address": {
                                "name": item?.end?.location?.address?.name,
                                "building": item?.end?.location?.address?.building,
                                "locality": item?.end?.location?.address?.locality,
                                "city": item?.end?.location?.address?.city,
                                "state": item?.end?.location?.address?.state,
                                "country": item?.end?.location?.address?.country,
                                "area_code": item?.end?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.end?.contact?.phone || '',
                            "email": item?.end?.contact?.email || ''
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null
                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "agent": {},
                    "vehicle": {
                        "vehicleCategoryId": item?.vehicle?.vehicleCategoryId,
                        "vehicleId": item?.vehicle?.vehicleId,
                        "vehicleName": item?.vehicle?.vehicleName,
                        "VehicleBodyTypeId": item?.vehicle?.VehicleBodyTypeId,
                        "weight": item?.vehicle?.weight,
                        "loading_capacity": item?.vehicle?.loading_capacity,
                        "registration": item?.vehicle?.registration,
                        "TripVehicleBasePrice": item?.vehicle?.TripVehicleBasePrice,
                    },
                    "EWayBill": {
                        "MediaFiles": isMediaFile ? mediaFiles : [],
                        "Templates": []
                    },
                    "@ondc/org/ewaybillno": null,
                    "@ondc/org/ebnexpirydate": null,
                    "tags": [
                        {
                            "code": null,
                            "list": [
                                {
                                    "code": null,
                                    "value": null
                                }
                            ]
                        }
                    ]
                };
                return data;
            });
            const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
                let category = _.find(productTypesListItems?.result?.items, ['Id', item?.CategoryId]);
                let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
                const data = {
                    "CategoryName": category?.Name,
                    "CategoryId": item?.CategoryId,
                    "LogisticsProductId": item?.LogisticsProductId,
                    "LogisticsVariantId": item?.LogisticsVariantId,
                    "descriptor": {
                        "name": product?.Name
                    },
                    "quantity": {
                        "count": item?.quantity?.count,
                        "measure": {
                            "unit": item?.quantity?.measure?.unit,
                            "value": item?.quantity?.measure?.value
                        }
                    },

                    "price": {
                        "currency": item?.value?.currency,
                        "value": item?.value?.value
                    },
                    "dangerous_goods": item?.dangerous_goods
                };
                return data;
            });
            const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
                const data = {
                    code: item?.code,
                    list: item?.list?.map((listItem: any) => {
                        const data = {
                            "code": listItem?.code,
                            "value": listItem?.value
                        }
                        return data;

                    })
                };
                return data;
            });
            const orderData = {
                context: {
                    transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                    message_id: generateIds?.fulfillment_id,
                },
                message: {
                    order: {
                        created_at: moment.utc(),
                        updated_at: moment.utc(),
                        id: generateIds.order_id,
                        state: null,
                        IsCargoOrder: true,
                        provider: {
                            id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
                            locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
                        },
                        items: itemValues,
                        quote: {
                            price: {
                                currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
                                value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
                            },
                            TotalDistance: quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance,
                            breakup: breakupValues
                        },
                        fulfillments: fulfillmentValues,
                        "billing": {
                            "name": fulfillmentValues[0]?.start?.person?.name || '',
                            "address": {
                                "name": fulfillmentValues[0]?.start?.location?.address?.name || '',
                                "building": fulfillmentValues[0]?.start?.location?.address?.building || '',
                                "locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
                                "city": fulfillmentValues[0]?.start?.location?.address?.city || '',
                                "state": fulfillmentValues[0]?.start?.location?.address?.state || '',
                                "country": fulfillmentValues[0]?.start?.location?.address?.country || '',
                                "area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
                            },
                            "tax_number": '',
                            "phone": fulfillmentValues[0]?.start?.contact?.phone || '',
                            "email": fulfillmentValues[0]?.start?.contact?.email || '',

                        },
                        "payment": {
                            "@ondc/org/collection_amount": null,
                            "collected_by": null,
                            "type": null,
                            "@ondc/org/settlement_details": [
                                {
                                    "settlement_counterparty": null,
                                    "settlement_type": null,
                                    "upi_address": null,
                                    "settlement_bank_account_no": null,
                                    "settlement_ifsc_code": null
                                }
                            ]
                        },
                        "@ondc/org/linked_order": {
                            "items": linkedItemValues,
                            "provider": {
                                "descriptor": {
                                    "name": null
                                },
                                "address": {
                                    "name": organizationUnitLists?.result?.items[0]?.Name,
                                    "building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
                                    "locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
                                    "city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
                                    "state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
                                    "country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
                                    "area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
                                }
                            },
                            "order":
                            {
                                "id": null,
                                "weight": {
                                    "unit": "mm",
                                    "value": 600
                                },
                                "dimensions": {
                                    "length": {
                                        "unit": "mm",
                                        "value": 50
                                    },
                                    "breadth": {
                                        "unit": "mm",
                                        "value": 60
                                    },
                                    "height": {
                                        "unit": "mm",
                                        "value": 30
                                    }
                                }
                            }

                        },
                        "tags": tagValues,

                    }
                }
            }
            dispatch(orders.create({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
                entity: 'orderCreate',
                jsonData: {
                    Records: [orderData]
                }
            })).then(() => {
                setIsLoading(false)
                setEnableConfirm(false)
                setIsOrderPlaced(true);
                setIsOpenPayment(false)
            })
        }
    }, [isPaymentAdded])


    // Tutorial Steps

    const tutorialSteps = [
        {
            id: 1,
            title: 'Basic Details',
            subTitle: 'Basic Details',
            component: <CargoBasicInfoComponent
                dropLocations={dropLocations}
                pickupLocations={pickupLocations}
                setDropLocations={setDropLocations}
                setPickupLocations={setPickupLocations}
                handleChange={handleChange}
                cargoValues={cargoValues}
                filterCustomer={filterCustomer}
                handleCustomerSearch={handleCustomerSearch}
                customerListData={customerListData}
            />,
            display: true,
        },
        {
            id: 2,
            title: 'Order Details',
            subTitle: 'Order Details',
            component: (


                <>
                    <div className=' w-full'>

                        {leadItem ? <NewLeadPopup handleEstimateleadSubmit={handleEstimateleadSubmit}
                        /> : <></>}
                        {/* Address Details Card */}
                        <div className="bg-white shadow-md rounded-2xl w-full max-w-md mx-auto p-4 flex flex-col space-y-4">
                            {/* Pickup Address */}
                            <div>
                                <p className="text-sm font-semibold text-gray-700">Pickup Address</p>
                                <div className="relative group mt-1">
                                    <p className="text-xs text-gray-600 truncate">{pickupLocations?.description || "—"}</p>
                                    <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs p-2 rounded-lg shadow-lg max-w-xs z-10">
                                        {pickupLocations?.description}
                                    </div>
                                </div>
                            </div>

                            <div className="border-t border-gray-200"></div>

                            {/* Drop Address */}
                            <div>
                                <p className="text-sm font-semibold text-gray-700">Drop Address</p>
                                <div className="relative group mt-1">
                                    <p className="text-xs text-gray-600 truncate">{dropLocations?.description || "—"}</p>
                                    <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs p-2 rounded-lg shadow-lg max-w-xs z-10">
                                        {dropLocations?.description}
                                    </div>
                                </div>
                            </div>

                            <div className="border-t border-gray-200"></div>

                            {/* Name */}
                            <div>
                                <p className="text-sm font-semibold text-gray-700">Name</p>
                                <p className="text-xs text-gray-600 mt-1">{selectedEstimateItem?.Name || "—"}</p>
                            </div>

                            <div className="border-t border-gray-200"></div>

                            {/* Phone Number */}
                            <div>
                                <p className="text-sm font-semibold text-gray-700">Phone Number</p>
                                <p className="text-xs text-gray-600 mt-1">{selectedEstimateItem?.PhoneNumber || "—"}</p>
                            </div>

                            {/* Edit Button */}
                            <div className="pt-2">
                                <button
                                    onClick={onEdit}
                                    type="button"
                                    className="w-full py-2 px-6 rounded-xl bg-primary text-white font-medium shadow hover:bg-primary/90 transition"
                                >
                                    Edit
                                </button>
                            </div>
                        </div>

                        {/* Vehicle Cards */}

                        <VehicleCard
                            isButtonLoading={quoteDetails?.isLoading}
                            loadCapacity={vehicleCategoryData?.result?.items}
                            vehicleData={vehicleData?.result?.items}
                            handleEstimate={handleEstimate}
                            productTypeCargo={productTypeCargo}
                            selectedEstimateItem={selectedEstimateItem}
                            handleInnerFormChange={handleChange}
                        />

                        {/* Order Booking Popup */}
                        {
                            orderItem ? <NewEstimatePopup
                                handleSavePackageItem={handleSavePackageItem}
                                handleOrderBooking={handleOrderBooking} /> : <></>
                        }
                    </div>

                </>

            ),
            display: true,
        },

    ];


    const maxSteps = tutorialSteps.length;
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };





    // Start- ccAvenue function
    const encrypt1 = (plainText: string, workingKey: string): string => {
        // Create an MD5 hash of the workingKey
        const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

        // Initialization vector (IV)
        const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

        // Encrypt the plainText
        const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Return the encrypted text in hex format
        return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    };

    const handeCCAvenuePayment = (orderDetails: any) => {
        const workingKey =
            razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
        const accessCode =
            razorpaySettings.CCAvenue?.AccessCode;
        const merchantId =
            razorpaySettings.CCAvenue?.MerchantId;

        const companyName = localStorage.getItem("CompanyName");
        const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
        const tenant = companyName; //getBusinessCompanyName();

        // const guestTokenData = {
        // 	Channel: channel.SalesChannelName, //SalesChannelName(),
        // 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
        // 	StoreId: storeId,
        // 	SalesChannelId: ChannelId,
        // };
        // const accessTokenData = {
        // 	PhoneNumber: userInfo[0]?.PhoneNumber,
        // 	TenantName: tenant,
        // 	SalesChannelId: ChannelId,
        // };
        const ccAvenueData = {
            merchant_id: merchantId,
            order_id: orderDetails?.order?.id,
            currency: 'INR',
            amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
            //   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
            //   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
            //   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

            // ENABLE FOR PRODUCTION
            redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
            cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
            language: 'EN',
            billing_name: orderDetails?.order?.billing?.name,
            billing_address: orderDetails?.order?.billing?.address?.name,
            billing_city: orderDetails?.order?.billing?.address?.city,
            billing_state: orderDetails?.order?.billing?.address?.state,
            billing_zip: orderDetails?.order?.billing?.address?.area_code,
            billing_country: orderDetails?.order?.billing?.address?.country,
            billing_tel: userProfileData?.PhoneNumber,
            billing_email: userProfileData?.Email,
            delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
            delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
            delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
            delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
            delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
            delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
            merchant_param1: tenant, //getOrganizationName(),
            merchant_param2: tenantId,
            merchant_param3: `${window.location.hostname}`,
            merchant_param4: 'transport-agent/cargo/order-details',
            merchant_param5: '',
            integration_type: 'iframe_normal',
            // promo_code:'PROMO8513',
            customer_identifier: userProfileData?.Email,
        };

        const body = queryString.stringify(ccAvenueData);

        const encRequest1 = encrypt1(body, workingKey);
        // let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
        let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;

        window.location.href = URL;
        // router.push(URL);
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
    }
    // End - ccAvenue function

    useEffect(() => {
        setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);

    }, [paymentMethodQuery]);

    useEffect(() => {
        if (paymentMode) {
            if (paymentMode.name == 'Cash' || paymentMode.name == 'Wallet') {
                setPaymentGateway([]);
                setEnablePlaceOrder(true)
            } else if (paymentMode && razorpaySettings) {
                const gateways: any = []
                if (razorpaySettings?.RazorPay?.IsActive) {
                    gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
                }
                if (razorpaySettings?.CCAvenue?.IsActive) {
                    gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
                }
                if (razorpaySettings?.PhonePe?.IsActive) {
                    gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
                }
                setPaymentGateway(gateways);
                setEnablePlaceOrder(true)
            } else {
                setEnablePlaceOrder(false)
            }
        }
    }, [paymentMode])

    useEffect(() => {
        if (isOrderPlaced) {
            switch (selected) {
                case 10: //cash payment
                    navigate('/transport-agent/cargo/order-details')
                    setOrderItem(undefined)
                    dispatch(cargoLeads.resetAction({ actionType: 'create' }))
                    break;
                case 20: //online
                    switch (paymentGateway[0]?.Id) {
                        case 10: //razorpay
                            // handeRazorpay()
                            break;
                        case 20: //ccavenue
                            handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
                            break;
                        case 30: //phonepe
                            break;
                        default:
                    }


                    break;
                case 30: //wallet
                    break;
            }

        }
    }, [isOrderPlaced])

    //Back to Booking
    const handleBack = () => {
        generateIdValue()
        setOrderItem(undefined)
        setIsQuote(false)
        setEnableConfirm(false)
        setIsOpenPayment(false)
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
        navigate('/transport-agent/bookings/cargo')
    };
    //Back to Order screen
    const handleBackToOrder = async () => {

        await setOrderItem(undefined)
        await setCargoValues({})
        await setIsQuote(false)
        await setPickupLocations({
            name: '',
            lat: '',
            lng: '',
            pincode: '',
            description: '',
        })
        await setDropLocations({
            name: '',
            lat: '',
            lng: '',
            pincode: '',
            description: '',
        })
        await setEnableConfirm(false)
        await setIsOpenPayment(false)
        await setActiveStep((prevActiveStep) => prevActiveStep - 1)
        await navigate('/transport-agent/bookings')
    }

    // Common Use Effect
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" })
        generateIdValue()
        dispatch(vehicles.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {

            }
        })).then(() => {
            dispatch(vehicleCategories.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/list`, entity: 'vehicles', jsonData: {}
            }));
        }).then(() => {
            dispatch(categories.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
                entity: 'categories',
                jsonData: {}
            }));
        }).then(() => {
            dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
        }).then(() => {
            dispatch(productTypes.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/product-types/list`, entity: 'productTypes', jsonData: {} }))
        })
    }, [])

    return (
        <div className="block sm:hidden w-full overflow-auto px-2">

            <div className="max-w-sm mx-auto p-2">



                <div className="border-b p-2 text-center text-xl font-bold">
                    {tutorialSteps[activeStep]?.title}
                </div>

                <div className="w-full flex flex-col p-3 border-b py-5 ">
                    <div className="flex flex-col w-full space-y-3">
                        {tutorialSteps[activeStep]?.component}
                    </div>
                </div>

                <div className="flex p-3 flex-col space-y-2 pb-20">

                    <div className="flex flex-row justify-end items-center space-x-2">
                        {activeStep == 0 && (<button onClick={handleBackToOrder} className={`bg-primary text-light  border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
                            Back											</button>)}
                        {activeStep !== 0 && (<button onClick={handleBack} className={`bg-primary text-light  border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
                            Back											</button>)}
                        {tutorialSteps[activeStep]?.id === 1 && (<button
                            onClick={handleLeadSubmit}
                            disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary'}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
                            Next
                            {isButtonLoading && <div className={`${isButtonLoading ? 'visible pl-1' : 'invisible'}`}>
                                <RotatingLines
                                    visible={true}
                                    width={'15'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </div>}
                        </button>)}

                    </div>

                </div>


            </div>



        </div>

    );
};

export default CargoBookings;


